import { FullPriceModal } from '@cian/frontend-newbuilding-promo-modal-widget';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectBookedFromDeveloperEnabled } from 'shared/selectors';
import { selectIsBookedFromDeveloper } from 'shared/selectors/newbuildingBookedFromDeveloper';

import { FullPriceEntry } from '../../components/FullPriceEntry';
import { selectFullPaymentTerm } from '../../selectors/purchaseTerms/purchaseTermsV2';
import { selectLinkedPromos } from '../../selectors/purchaseTerms/selectLinkedPromos';
import { PromoModalActionsContainer } from '../PromoModalActionsContainer';
import { trackPurchaseTermClick } from '../PurchaseTermsContainer/tracking';

export const FullPriceContainer: React.FC = () => {
  const fullPaymentTerm = useSelector(selectFullPaymentTerm);
  const linkedPromos = useSelector(selectLinkedPromos);
  const isBooked = useSelector(selectIsBookedFromDeveloper);
  const bookedFromDeveloperEnabled = useSelector(selectBookedFromDeveloperEnabled);

  const isBookedFromDeveloper = isBooked && bookedFromDeveloperEnabled;

  const [isOpen, setIsOpen] = React.useState(false);

  const onClick = React.useCallback(() => {
    setIsOpen(true);
    trackPurchaseTermClick({
      type: 'fullPayment',
      source: 'Card',
    });
  }, []);

  const onClose = React.useCallback(() => {
    setIsOpen(false);
  }, []);

  if (!fullPaymentTerm) {
    return null;
  }

  return (
    <>
      <FullPriceEntry onClick={onClick} isMutedText={isBookedFromDeveloper} />
      {isOpen && (
        <FullPriceModal
          open={isOpen}
          onClose={onClose}
          description={fullPaymentTerm.dialog.promoDescription}
          linkedPromos={linkedPromos}
          linkedPromosTitle={fullPaymentTerm.dialog.linkedPromos?.title}
          linkedPromosSubtitle={fullPaymentTerm.dialog.linkedPromos?.subtitle}
          controls={<PromoModalActionsContainer modalType="purchase_term_modal" onModalClose={onClose} />}
        />
      )}
    </>
  );
};
